// Whether this page is running inside the desktop app's dashboard webview.
//
// The desktop's preload (agent/packages/desktop/src/preload/dashboard.ts)
// exposes `moderniserDesktop` before any page script runs; no browser has it,
// so presence is the whole test. Read once at module load — the flag cannot
// change while the page lives.
export const inDesktop = "moderniserDesktop" in window
